module.exports = __webpack_public_path__ + "img/no_zone.386db699.svg";